var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDasshboardOccupations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.286,
    height: 27.375,
    viewBox: "0 0 31.286 27.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Experience_necktie",
    transform: "translate(-46 -72.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8427",
    "data-name": "Path 8427",
    d: "M321.67,129.289l-3.165-.829-4.443,6.737a2.075,2.075,0,0,1-1.643.933l1.768,11.284a2.094,2.094,0,0,1-.584,1.8l-.48.48H323.86V132.126A2.924,2.924,0,0,0,321.67,129.289Z",
    transform: "translate(-246.574 -52.023)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8428",
    "data-name": "Path 8428",
    d: "M57.445,136.13A2.075,2.075,0,0,1,55.8,135.2L51.36,128.46l-3.165.829a2.929,2.929,0,0,0-2.2,2.837v17.567H56.736l-.48-.48a2.094,2.094,0,0,1-.584-1.8Z",
    transform: "translate(0 -52.023)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8429",
    "data-name": "Path 8429",
    d: "M209.5,179.145l-2.086-2.805-2.086,2.811.13.448L203.5,192.051l3.911,3.911,3.911-3.911L209.366,179.6Z",
    transform: "translate(-145.768 -96.336)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8430",
    "data-name": "Path 8430",
    d: "M263.575,72.25l-7.542,4.26,4.1,5.517,4.7-7.123Z",
    transform: "translate(-194.388)",
    fill: "#37bdb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8431",
    "data-name": "Path 8431",
    d: "M137.908,74.9l4.7,7.123,4.1-5.517-7.542-4.26Z",
    transform: "translate(-85.062)",
    fill: "#37bdb0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDasshboardOccupations);
export default __webpack_public_path__ + "static/media/Dasshboard_Occupations.814f0849a93b1c1c4bc309d26b0c1966.svg";
export { ForwardRef as ReactComponent };